import { mutatorAction } from 'satcheljs';
import { SaveCalendarViewConfig } from '../store/schema/SaveCalendarViewConfig';
import { getStore } from '../store/store';

export const updateStoreFromOws = mutatorAction(
    'updateStoreFromOws',
    (savedViews: SaveCalendarViewConfig[]) => {
        // The saved views return from OWS in reverse, so we must flip them back.
        savedViews.reverse();
        savedViews.forEach(savedView => {
            getStore().savedViewMap.set(savedView.id, savedView);
        });
        getStore().isLoaded = true;
    }
);
